import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import styles from "../styles/mainPage.module.css";

import { claimItem, getUsers, unclaimItem } from '../api/Api';
import List from './ListComponent';
import ErrorMessage from './helpers/ErrorMessageComponent';

function Lists(props) {
  // ---------------------------------------------------------------- state and hooks

  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(props.user);
  const [selectedUserObj, setSelectedUserObj] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    const userObj = users.find((u) => u.name === selectedUser);
    if (userObj) {
      setSelectedUserObj(userObj);
    }
  }, [users, selectedUser]);

  // ---------------------------------------------------------------- logic

  function resetUser() {
    sessionStorage.removeItem('user');
    window.location.reload();
  }

  async function claimItemHandler(id) {
    await claimItem(id)
      .then(() => fetchUsers())
      .catch(() => {
        setError('Something went wrong');
      });
  }

  async function unclaimItemHandler(id) {
    await unclaimItem(id)
      .then(() => fetchUsers())
      .catch(() => {
        setError('Something went wrong');
      });
  }

  // ---------------------------------------------------------------- render

  async function fetchUsers() {
    await getUsers()
      .then((users) => {
        setUsers(users);
      })
      .catch((error) => {
        console.log(error);
        setError('Something went wrong');
      });
  }

  const userOptions = users.map((user) => (
    <option
      key={user.name}
      value={user.name}>
      {`${user.name}${user.name === props.user ? ' (me!)' : ''}`}
    </option>
  ));

  function list() {
    if (selectedUserObj === null) {
      return <div>Loading...</div>;
    }

    return (
      <List
        selectedUser={selectedUser}
        fetchUsers={fetchUsers}
        items={selectedUserObj.askedItems}
        claims={selectedUserObj.claimedItems}
        claimItemHandler={claimItemHandler}
        unclaimItemHandler={unclaimItemHandler}
      />
    );
  }

  return (
    <div style={{ paddingBottom: '50px' }} className={styles.container}>
      <h1 className={styles.header}>Welcome</h1>
      <h1 className={styles.subheader}>{props.user}</h1>

      <button
        style={{ marginBottom: '30px' }}
        onClick={resetUser}>
        Change user
      </button>

      <div
        style={{
          marginBottom: '10px',
        }}>
        Select list:
        <select
          style={{
            marginLeft: '.5em',
          }}
          value={selectedUser}
          onChange={(event) => setSelectedUser(event.target.value)}>
          {userOptions}
        </select>
      </div>

      {list()}

      <ErrorMessage message={error} />
    </div>
  );
}

Lists.propTypes = {
  user: PropTypes.string,
};

export default Lists;
